import { Component } from '@angular/core';

@Component({
  selector: 'app-pqcifris25',
  templateUrl: './pqcifris25.component.html',
  styleUrl: './pqcifris25.component.css'
})
export class pqcifris25Component {

}
